import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import { ContPlan } from '@/common/constants';
import Tenant from '@/types/Tenant.type';

type Props = {
  onEdit: (id: number) => void;
  rows: Array<Tenant>;
};

const TenantTableBody: React.FC<Props> = ({ onEdit, rows }) => {
  return (
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.id}>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.adminName}</TableCell>
          <TableCell>
            {row.contPlan === ContPlan.有償 && '有償'}
            {row.contPlan === ContPlan.無償 && '無償'}
          </TableCell>
          <TableCell>{row.startDate}</TableCell>
          <TableCell>{row.endDate}</TableCell>
          <TableCell>
            <IconButton onClick={() => onEdit(row.id)}>
              <EditIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};
export default TenantTableBody;
